import React, { useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";

// Predefined responses
const fixedResponses = {
  "hello": "Hi there! How can I help you?",
  "how are you": "I'm doing great, thank you for asking!",
  "what is your name": "I am your friendly chatbot.",
  "bye": "Goodbye! Have a great day!",
};

const ChatBot = ({ client, closeChat }) => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");

  // Function to handle sending messages
  const handleSendMessage = () => {
    if (userInput.trim()) {
      const userMessage = userInput.toLowerCase().trim();
      const botReply = fixedResponses[userMessage] || "Sorry, I didn't understand that.";

      // Add the user message to the chat
      setMessages((prevMessages) => [
        ...prevMessages,
        { sender: "user", message: userInput },
      ]);

      // Add the bot reply to the chat
      setMessages((prevMessages) => [
        ...prevMessages,
        { sender: "bot", message: botReply },
      ]);

      setUserInput("");  // Clear input field
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "20px", // Adjust this to set the chatbot's distance from the bottom of the screen
        right: "20px",  // Adjust this to set the chatbot's distance from the right of the screen
        width: "300px",
        maxWidth: "90%", // Responsive width for smaller screens
        backgroundColor: "#ffffff",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: "10px",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" align="center" gutterBottom>
        Chat with {client.name}
      </Typography>

      {/* Close button for the chat */}
      <Button
        onClick={closeChat}
        sx={{
          alignSelf: "flex-end",
          backgroundColor: "#ff4d4d",
          color: "#fff",
          borderRadius: "50%",
          width: "30px",
          height: "30px",
          padding: 0,
          minWidth: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        X
      </Button>

      <Box sx={{ maxHeight: "300px", overflowY: "auto", marginBottom: "10px" }}>
        {messages.map((msg, index) => (
          <Box key={index} sx={{ textAlign: msg.sender === "user" ? "right" : "left" }}>
            <Typography
              variant="body1"
              sx={{
                backgroundColor: msg.sender === "user" ? "#fff" : "#e0e0e0",
                padding: 1,
                borderRadius: 1,
                maxWidth: "80%",
                margin: "10px",
                color: msg.sender === "user" ? "#fff" : "#000",
              }}
            >
              {msg.message}
            </Typography>
          </Box>
        ))}
      </Box>

      <TextField
        variant="outlined"
        fullWidth
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        label="Type a message..."
        sx={{ marginBottom: 2 }}
      />

      <Button
        variant="contained"
        onClick={handleSendMessage}
        sx={{ width: "100%" }}
      >
        Send
      </Button>
    </Box>
  );
};

export default ChatBot;
